export default __webpack_public_path__ + "static/media/takeAPunt.1d42f617.png";